import { useEffect, useState } from "react";
import axios from "axios";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SettingsIcon from "@mui/icons-material/Settings";
import { FaFolderOpen, FaPlusCircle, FaUserEdit } from "react-icons/fa";
import UserApi from "../api/UserApi";
import enumMapper from "../enumMapper";
import { MdDescription } from "react-icons/md";
import Loading from "../Components/Loading";
import helper from "../helper";

// Map API icon names to MUI icons
const iconMap = {
  dashboard: <DashboardIcon fontSize="large" />,
  users: <PeopleIcon fontSize="large" />,
  orders: <ShoppingCartIcon fontSize="large" />,
  settings: <SettingsIcon fontSize="large" />,
  FaUserEdit:<FaUserEdit size={40}/>,
  FaPlusCircle:<FaPlusCircle size={40}/>,
  FaFolderOpen:<FaFolderOpen size={40}/>,
  MdDescription:<MdDescription size={40}/>
};

export default function DashboardMenu() {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await UserApi.GetDashboardItems(enumMapper.AppId.GuestService); // your API
        const data = response.data;

        const mappedMenu = data.map((item) => ({
          title: item.title,
          path: "/Dashboard/" + helper.GetPath(item.menuName,item.params),
          icon: iconMap[item.icon] || <DashboardIcon fontSize="large" />,
        }));

        setMenuItems(mappedMenu);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchMenu();
  }, []);

  // Render skeletons while loading
 if (loading)
  return (
    <Loading/>
  );

  if (error)
    return (
      <Box display="flex" justifyContent="center" py={5}>
        <Typography color="error">{error}</Typography>
      </Box>
    );

  return (
    <Grid container spacing={3}>
      {menuItems.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Card
            sx={{
              height: "100%",
              borderRadius: 3,
              transition: "0.3s",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-5px)",
              },
            }}
          >
            <CardActionArea
              component={RouterLink}
              to={item.path}
              sx={{ height: "100%" }}
              aria-label={`Go to ${item.title}`}
            >
              <CardContent>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  gap={2}
                  py={3}
                >
                  {item.icon}
                  <Typography variant="h6" fontWeight="bold">
                    {item.title}
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
